module.exports = __webpack_public_path__ + "img/no room selected.f7bfbbd8.png";